type LoadLike = {
  id?: string | number;
  quantities?: number;
  grossWeight?: number;
  cubicMeters?: number;
  consideredWeight?: number;
  cubeWeight?: number;
};

export const buildLogisticLoadsPayload = (load: LoadLike | undefined) => ({
  logisticLoads: [
    {
      id: load?.id,
      quantities: load?.quantities,
      grossWeight: load?.grossWeight,
      cubicMeters: load?.cubicMeters,
      consideredWeight: load?.consideredWeight,
      cubeWeight: load?.cubeWeight,
    },
  ],
});
